import React, { useState, useRef, useEffect } from "react";
import YouTubePlayer from './YouTubePlayer'
import Skin from './Skin'
import Loader from './Loader'
import { useYouTubePlayer } from '../hooks/useYouTubePlayer'
import { useFullscreen } from '../hooks/useFullscreen'
import { isMobile, useMobileOrientation } from 'react-device-detect'
import ReturnToMovies from './returntomovies/ReturnToMovies'
import RotateScreen from './rotatescreen/RotateScreen'

import '../css/main.css'
import '../css/buttons.css'
import '../css/video.css'
import '../css/filters.css'
import '../css/ranges.css'
import '../css/checkbox.css'
import '../css/movie_info.css'
import '../css/loader.css'

export default function Layout({ 
    movie,
    nav,
    filterControls,
    searchControls,
}) {

    const { isFullscreen, canFullscreen, requestFullscreenOnMobile } = useFullscreen();
     
    const [state, setState] = useState({
        skinVisible: true,
        loaded: false
    });

    const {
        playerLoaded,
        videoVisible,
        mute,
        onVideoReady,
        playVideo,
        pauseVideo,
        hideVideo,
        showVideo,
        toggleMute,
        getPlayerState,
    } = useYouTubePlayer();
    
    const skinTimeoutRef = useRef(null);
    const keepSkinVisibleRef = useRef(false);
    const player = { toggleMute, mute, hideVideo, playVideo, pauseVideo, getPlayerState };
    const [keepSkinVisible, setKeepSkinVisible] = useState(false);
    // Bumped when the landing page's TAKE THE TOUR is pressed; Skin starts the tour on change
    const [tourRequest, setTourRequest] = useState(0);

    useEffect(() => {
        keepSkinVisibleRef.current = keepSkinVisible;
    }, [keepSkinVisible]);

    useEffect(() => {
        return () => clearTimeout(skinTimeoutRef.current);
    }, []);

    const removeLoader = (tour) => {
        setState(prev => ({ ...prev, loaded: true }));
        playVideo();
        // Request fullscreen on mobile devices when the loader is removed
        requestFullscreenOnMobile();
        if (tour) setTourRequest((n) => n + 1);
    }

    const showSkin = () => {
        /*
        Shows the skin, then after a timeout hides the skin
        */
        /* Set state to show skin */
        if (!state.loaded) return;
        setState(prev => ({ ...prev, skinVisible: true }));
        document.querySelector("body").style.cursor = "auto"

        /* Reset the any previous timeouts on the skin.
           This prevents the skin timing out/disappearing early*/
        clearTimeout(skinTimeoutRef.current);
        /* Set state to hide skin in 4s, if video is not paused */
        skinTimeoutRef.current = setTimeout(() => {
            const stateVal = getPlayerState();
            if ((stateVal === 1 || stateVal === undefined ) && !keepSkinVisibleRef.current) {
                setState(prev => ({ ...prev, skinVisible: false }));
                document.querySelector("body").style.cursor = "none"
            }
        }, 3000)
    }

    const renderVideo = () => {
        return (
            <YouTubePlayer
                videoId={movie.trailer}
                onReady={onVideoReady}
                onPlay={onPlay}
                onPause={onPause}
                onEnd={nav.getNextMovie}
                onStateChange={videoStateChange}
            />
        )
    }

    const videoStateChange = () => {
        const stateVal = getPlayerState();
        if (stateVal == 5 && state.loaded) {
            playVideo()
        }
    }

    const onPlay = () => {
        setKeepSkinVisible(false)
        showSkin();
        showVideo();
    }

    const onPause = () => {
        setKeepSkinVisible(true)
        showSkin();
    }

    const onSkinClick = (e) => {
        // if(e.target !== e.currentTarget) return
        const stateVal = getPlayerState();
        if (stateVal === 1) {
            pauseVideo()
            // hideVideo()
        } else if (stateVal === 2) {
            playVideo()
            showSkin()
        }
    }
    const { isPortrait } = useMobileOrientation();
    const showReturnToMovies = isMobile && canFullscreen && !isFullscreen && state.loaded;
    const showRotateScreen = isMobile && isPortrait && state.loaded;

    return (
        <div className="app">
            <ReturnToMovies show={showReturnToMovies} />
            <RotateScreen show={showRotateScreen} />
            
            {!state.loaded ? <Loader loaded={playerLoaded} onRunApp={removeLoader} /> : null}
            <div style={{height: "100%", width: "100%", position: "fixed"}}>
                <div className={movie.movieFound && videoVisible ? "" : "transparent"}>
                    {renderVideo()}
                </div>
                <div style={{height: "100%", width: "100%", position: "fixed", top: 0}} className={state.skinVisible ? "" : "transparent"} 
                     onMouseMove={showSkin}
                     onMouseDown={onSkinClick}>
                    <Skin 
                        movie={movie}
                        nav={nav}
                        player={player}
                        filterControls={filterControls}
                        searchControls={searchControls}
                        setKeepSkinVisible={setKeepSkinVisible}
                        tourRequest={tourRequest}
                    />
                </div>
            </div>
        </div>
    );
}
